import { ErrorComponentProps } from '@sitecore-jss/sitecore-jss-react-forms';

const FormValidationError: React.FC<ErrorComponentProps> = (props) => (
  <>
    {props.formErrors.map((error, index) => (
      <p className="basis-full px-3 text-xs font-bold text-error" key={`form-wide-error-${index}`}>
        {error}
      </p>
    ))}
    <br />
  </>
);
export default FormValidationError;
